import { Reflector } from '../reflection';
export function Catch(error) {
  return function (Target) {
    Reflector.addCatchDecoratorMetadata(Target, error);
  };
}

Catch.getMetadata = function (Target) {
  return Reflector.getCatchDecoratorMetadata(Target);
};

Catch.catches = function (handler, error) {
  var ErrorClass = Catch.getMetadata(handler.constructor);
  return ErrorClass != null && error instanceof ErrorClass;
};